import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { DragDropContext, DragSource, DropTarget } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import {
  Layout,
  Breadcrumb,
  Form,
  Input,
  DatePicker,
  Radio,
  Modal,
  Select,
  Switch,
  Button,
  Table,
  message,
  notification,
  Skeleton,
  InputNumber,
  List,
  Divider,
  Avatar,
  Checkbox,
} from "antd";
import {
  EyeOutlined,
  PictureOutlined,
  UploadOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import update from "immutability-helper";
import _ from "lodash";
import Errors from "validatorjs/src/errors";
import moment from "moment";

import WUpload from "components/WUpload/WUpload";
import DeleteConfirmButton from "components/DeleteConfirmButton/DeleteConfirmButton";
import ValidatorErrorAlert from "components/ValidatorErrorAlert/ValidatorErrorAlert";

import whttp from "libs/whttp";
import AppHelper from "libs/AppHelper";
import { genFormItemAtrribute } from "libs/FormHelper";

import { API_HOST } from "configs/env";
import styles from "./styles.module.scss";

const devNewsInfo = {
  name: "最新消息名稱",
  type: 1,
  desc: "內容",
  sort: 99,
  logo: null,
  pdfs: [],
  images: [],
};

function ImageSize(category) {
  //大Banner
  if (category == 50) return "建議尺寸: 1440 x 640";
  //中Banner
  else if (category == 53) return "建議尺寸: 1200 x 600";
  //美食購物, 品牌列表 Banner
  else if (category == 54 || category == 110) return "建議尺寸: 1080 x 400";
  //活動消息
  else
    return "封面建議尺寸: 1200 x 600 (2:1) ; 內頁建議尺寸: 最小寬度1080以上即可";
}

@DragDropContext(HTML5Backend)
export default class NewsInfo extends Component {
  formRef = React.createRef();

  state = {
    newsInfo: {
      id: null,
      status: 1,
      name: null,
      logo: null,
      type: 1,
      action_type: 0,
      category_id: null,
      is_middle_banner: 0,
      app_status: 1,
    },
    data: [],
    messages: {},
    isFetchData: false,
    isSubmitData: false,
    cate: null,
    cateName: null,
    brandList: [],
    selectState: false,
    selbrandList: [],
  };

  componentDidMount() {
    AppHelper.updateConfig();
    this.fetchData();
    this.fillData();
    this.fetchBrands();
  }

  fillData = (data = _.cloneDeep(devNewsInfo)) => {
    if (!this.formRef.current) return;
    data.show_range0 = _.get(data, "show_at")
      ? moment(_.get(data, "show_at"))
      : null;
    data.show_range1 = _.get(data, "hide_at")
      ? moment(_.get(data, "hide_at"))
      : null;
    data.date_range = [
      moment(_.get(data, "start_date")),
      moment(_.get(data, "end_date")),
    ];

    if (!_.isBoolean(data.status)) {
      data.status = data.status === 1;
    }
    if (!_.isBoolean(data.app_status)) {
      data.app_status = data.app_status === 1;
    }
    if (!_.isBoolean(data.is_middle_banner)) {
      data.is_middle_banner = data.is_middle_banner === 1;
    }

    data.images.forEach((item, idx) => {
      if (item.path == null || item.url == null) {
        data.images.splice(idx, 1);
      }
    });
    this.formRef.current.setFieldsValue(data);
  };

  fetchData = () => {
    const id = _.get(this, "props.match.params.id");
    if (!id) return;
    this.setState({ isFetchData: true });
    whttp.get(API_HOST + `/api/mgt/v1/news/${id}`, null, (state, res) => {
      this.setState({ isFetchData: false });

      const { code = 100, reason = "發生錯誤", data = {} } = res;

      console.log(code, reason, data, res);

      if (state === false || code !== 200) {
        message.warning(reason);
        this.props.history.replace("/news");
        return;
      }

      this.fillData(data);
    });
  };

  fetchBrands = () => {
    whttp.get(
      `${API_HOST}/api/mgt/v1/brands`,
      {
        per_page: 10000,
        status: 1,
      },
      (state, res) => {
        const { code = 100, reason = "發生錯誤", data = {} } = res;
        if (state === false) {
          return this.setState({ message: "發生錯誤" });
        }
        if (code !== 200) {
          return this.setState({ message: reason });
        }
        this.setState({ brandList: data.rows });
      }
    );
  };

  submitData = (newsInfo = {}) => {
    console.log("submitData start", newsInfo);
    if (this.getFieldValue("category_id") === 131) {
      newsInfo.action_type = 0;
      newsInfo.type = 0;
      newsInfo.app_status = false;
    }
    // 把Control元件轉換回上傳資料
    newsInfo.cover = _.get(newsInfo, "cover.path");
    newsInfo.show_at = _.get(newsInfo, "show_range0")
      ? _.get(newsInfo, "show_range0").format("YYYY-MM-DD HH:mm:ss")
      : "";
    newsInfo.hide_at = _.get(newsInfo, "show_range1")
      ? _.get(newsInfo, "show_range1").format("YYYY-MM-DD HH:mm:ss")
      : "";
    newsInfo.start_date = _.get(newsInfo, "date_range.0").format("YYYY-MM-DD");
    newsInfo.end_date = _.get(newsInfo, "date_range.1").format("YYYY-MM-DD");
    newsInfo.category_id = this.getFieldValue("category_id");
    if (this.getFieldValue("category_id") === 53) {
      newsInfo.is_middle_banner = 1;
    }
    const current_user = _.get(window, "VC_CONFIG.WP_CURRENT_USER", "");
    newsInfo.user_id = current_user.ID;
    const id = _.get(this, "props.match.params.id", "");
    this.setState({ isSubmitData: true, messages: {} });

    console.log("submitData end", newsInfo);

    whttp.post(API_HOST + `/api/mgt/v1/news/${id}`, newsInfo, (state, res) => {
      this.setState({ isSubmitData: false });
      const { code = 100, reason = "發生錯誤", data = {} } = res;
      if (state === false) {
        return message.error("發生錯誤");
      }
      if (code !== 200) {
        notification["error"]({
          message: "更新失敗",
          description: reason,
        });
        const messages = data.messages;
        if (_.isObject(messages)) {
          //處理錯誤訊息
          _.map(messages, (errors, key) => {
            console.log("map", key, errors);
            return {
              touched: true,
              validating: false,
              errors: [],
              name: [key],
              value: this.getFieldValue(key),
            };
          });
          this.forceUpdate();
        }
        return this.setState({ messages: data.messages || {} });
      }
      const { data: { id: new_id } = {} } = res;
      if (new_id != id) {
        message.success("新增成功");
        this.fillData(data);
        this.linkInsert();
      } else {
        message.success("更新成功");
        this.fillData(data);
        this.linkInsert();
      }
    });
  };

  deleteData = (item) => {
    if (_.isNil(item.id)) return;
    item.isDeleteData = true;
    this.setState({ isDeleteData: true });

    whttp.delete(API_HOST + `/api/mgt/v1/news/${item.id}`, {}, (state, res) => {
      item.isDeleteData = false;
      this.setState({ isDeleteData: false });
      const { code = 100, reason = "發生錯誤", data = {} } = res;

      if (state === false) {
        return message.error("發生錯誤");
      }

      if (code !== 200) {
        return message.error(reason);
      }

      message.success("刪除成功");

      this.loadData();
    });
  };

  cloneData = (item) => {
    if (_.isNil(item.id)) return;

    item.isCloneData = true;

    this.setState({ isCloneData: true });

    whttp.post(
      API_HOST + `/api/mgt/v1/news/${item.id}/clone`,
      {},
      (state, res) => {
        item.isCloneData = false;
        this.setState({ isCloneData: false });
        const { code = 100, reason = "發生錯誤", data = {} } = res;

        if (state === false) {
          return message.error("發生錯誤");
        }

        if (code !== 200) {
          return message.error(reason);
        }

        message.success("複製成功");

        if (!_.isNil(data.id)) this.props.history.push(`/news/view/${data.id}`);
      }
    );
  };

  getImages = () => {
    return this.formRef.current &&
      _.isArray(this.formRef.current.getFieldValue("images"))
      ? this.formRef.current.getFieldValue("images")
      : [];
  };

  moveRow = (dragIndex, hoverIndex) => {
    const { table_data = {}, table_data: { rows = [] } = {} } = this.state;
    let images = this.getImages();
    const dragRow = images[dragIndex];

    images = update(images, {
      $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
    });

    this.formRef.current.setFields([
      {
        touched: true,
        validating: false,
        errors: [],
        name: ["images"],
        value: images,
      },
    ]);
  };

  getFieldValue = (key, defaultValue = undefined) => {
    return this.formRef.current
      ? this.formRef.current.getFieldValue(key)
      : defaultValue;
  };

  openPost = (e) => {
    e.preventDefault();
    const newsInfo = this.formRef.current.getFieldValue();
    window.formRef = this.formRef;
    window.newsInfo = newsInfo;
    window.Post = _.get(window, "wp.api.models.Post");
    const Post = _.get(window, "wp.api.models.Post");

    let post_id = _.get(newsInfo, "post_id");
    console.log("newsInfo", newsInfo);
    console.log("post_id", _.isNil(post_id), post_id);

    let WP_ADMIN_URL = _.get(window, "VC_CONFIG.WP_ADMIN_URL");

    if (post_id && post_id > 0) {
      window.open(WP_ADMIN_URL + `post.php?post=${post_id}&action=edit`);
      return;
    }

    this.setState({ isOpeningPost: true });

    let post = new Post({
      title: _.get(newsInfo, "name"),
    });

    post.save().done(() => {
      this.setState({ isOpeningPost: false });
      console.log("post", post);
      console.log(WP_ADMIN_URL + `post.php?post=${post.id}&action=edit`);
      window.open(WP_ADMIN_URL + `post.php?post=${post.id}&action=edit`);
      newsInfo.post_id = post.id;
      this.submitData(newsInfo);
    });
  };

  //預覽最新消息列表
  previewNewsList = () => {
    const id = _.get(this, "props.match.params.id");
    let INDEX_URL = _.get(window, "VC_CONFIG.INDEX_URL");
    let category_name = this.getFieldValue("category_name");
    // 若為聯名卡活動，前方加上 uniopen
    if (category_name === "聯名卡活動") {
      category_name = `uniopen${category_name}`;
    }
    if (id && id > 0) {
      window.open(
        INDEX_URL +
          `/news-preview/?previewid=${id}&cname=${category_name}&mode=6`
      );
      return;
    }
  };

  enterNotSubmit = (e) => {
    if (e.key === "Enter") {
      let value = e.target + "";
      if (value.indexOf("TextArea") !== -1) {
        console.log("TextArea");
      } else e.preventDefault();
    }
  };

  // 將儲存的 category_ids 參數丟到網址列上
  linkInsert = () => {
    let category_id = AppHelper.getLocalStorage("category_ids");
    if (category_id === "undefined" || category_id === undefined) {
      console.log("category_id = undefined!");
      return this.props.history.replace(`/news/`);
    } else {
      AppHelper.removeLocalStorage("category_ids");
      return this.props.history.replace(`/news?category_id=` + category_id);
    }
  };

  render() {
    const { brandList, selectState, selbrandList } = this.state;
    // 登入使用者的權限
    const errors = _.get(this, "state.validator.errors", new Errors());
    const options = _.get(this, "props.app.options", {});
    const id = _.get(this, "props.match.params.id");
    const category_id = this.getFieldValue("category_id");
    window.getFieldValue = this.getFieldValue;

    return (
      <Layout className={styles.container}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to={`/news`}>消息資訊管理</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>消息資訊</Breadcrumb.Item>
        </Breadcrumb>
        <h2>
          消息資訊
          <span />
        </h2>
        <ValidatorErrorAlert errors={errors} />
        <Skeleton loading={this.state.isFetchData}>
          <div className="block search">
            <Form
              ref={this.formRef}
              name="basic"
              className="basicForm"
              layout="vertical"
              onFinish={(values) => this.submitData(values)}
              onKeyDown={(e) => this.enterNotSubmit(e)}
              onValuesChange={(changedFields, allFields) => {
                this.setState({
                  cate: this.getFieldValue("category_id"),
                  cateName: this.getFieldValue("category_name"),
                });
                const type = _.get(changedFields, "type");
                if (
                  this.getFieldValue("youtube") &&
                  this.getFieldValue("category_id") !== 50 &&
                  category_id !== 122
                ) {
                  this.formRef.current.setFields([
                    {
                      name: ["youtube"],
                      value: null,
                      touched: true,
                      validating: false,
                      errors: [],
                    },
                  ]);
                }
                if (!_.isNil(type)) {
                  if (type === 0) {
                    this.formRef.current.setFields([
                      {
                        name: ["store_id"],
                        value: null,
                        touched: true,
                        validating: false,
                        errors: [],
                      },
                      {
                        name: ["brand_ids"],
                        value: null,
                        touched: true,
                        validating: false,
                        errors: [],
                      },
                    ]);
                  }
                  if (type === 1) {
                    this.formRef.current.setFields([
                      {
                        name: ["brand_ids"],
                        value: null,
                        touched: true,
                        validating: false,
                        errors: [],
                      },
                    ]);
                  }
                  if (type === 2) {
                    this.formRef.current.setFields([
                      {
                        name: ["store_id"],
                        value: null,
                        touched: true,
                        validating: false,
                        errors: [],
                      },
                    ]);
                  }
                }
              }}
            >
              <Form.Item
                style={{ textAlign: "right" }}
                taillayout={{ wrapperCol: { offset: 8, span: 16 } }}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginLeft: 8 }}
                  loading={this.state.isSubmitData}
                >
                  儲存
                </Button>
                <Button
                  type="primary"
                  style={{ marginLeft: 8 }}
                  disabled={
                    id == undefined ||
                    !(
                      category_id == 42 ||
                      category_id == 43 ||
                      category_id == 44
                    )
                  }
                  onClick={this.previewNewsList}
                >
                  預覽列表
                </Button>
              </Form.Item>
              <div className="flexBox">
                <Form.Item
                  {...genFormItemAtrribute("name", "名稱")}
                  rules={[{ required: true, message: "請填寫名稱" }]}
                >
                  <Input defaultValue="最新消息名稱" />
                </Form.Item>
                <Form.Item
                  {...genFormItemAtrribute("sort", "排序")}
                  rules={[{ required: true, message: "請填寫排序" }]}
                  extra="數字最小者排在前面"
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    min={0}
                    max={99}
                    defaultValue={99}
                  />
                </Form.Item>
                <Form.Item
                  {...genFormItemAtrribute("status", "狀態", "checked")}
                >
                  <Switch checkedChildren="啟用" unCheckedChildren="停用" />
                </Form.Item>
              </div>
              <div className="flexBox">
                <Form.Item
                  {...genFormItemAtrribute("show_range0", "系統上架時間")}
                  extra="系統於該時段顯示於官網，注意狀態需為「啟用」。"
                >
                  <DatePicker
                    showTime={{
                      defaultValue: moment("09:00:00", "HH:mm:ss"),
                      format: "HH:mm",
                    }}
                    format="YYYY-MM-DD HH:mm"
                  />
                </Form.Item>

                <Form.Item
                  {...genFormItemAtrribute("show_range1", "系統下架時間")}
                  extra="系統於該時段顯示於官網，注意狀態需為「啟用」。"
                >
                  <DatePicker
                    showTime={{
                      defaultValue: moment("23:59:59", "HH:mm:ss"),
                      format: "HH:mm",
                    }}
                    format="YYYY-MM-DD HH:mm"
                  />
                </Form.Item>

                <Form.Item
                  {...genFormItemAtrribute("date_range", "活動日期")}
                  rules={[{ required: true, message: "請填寫促銷活動日期" }]}
                >
                  <DatePicker.RangePicker />
                </Form.Item>
              </div>
              <div className="flexBox">
                <Form.Item
                  name="category_id"
                  label="消息類別"
                  rules={[{ required: true, message: "請選擇消息類別" }]}
                >
                  <Select
                    showSearch
                    disabled={id !== undefined}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onSelect={(id) => {
                      if (id === 131) {
                        this.formRef.current.setFields([
                          {
                            name: ["ig"],
                            value: null,
                          },
                        ]);
                      }
                    }}
                  >
                    {_.map(_.get(options, "news_categories", []), (item) => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              {[131].includes(category_id) && (
                <div className="flexBox">
                  <Form.Item
                    name="ig"
                    label="IG 內嵌程式碼"
                    rules={[{ required: true, message: "必填" }]}
                  >
                    <Input.TextArea rows={10} />
                  </Form.Item>
                </div>
              )}
              {category_id !== 131 && (
                <React.Fragment>
                  <div className="flexBox">
                    <Form.Item
                      {...genFormItemAtrribute(
                        "is_middle_banner",
                        "中版位設定",
                        "checked"
                      )}
                    >
                      <Switch checkedChildren="啟用" unCheckedChildren="停用" />
                    </Form.Item>
                    <Form.Item
                      {...genFormItemAtrribute(
                        "app_status",
                        "APP最新消息",
                        "checked"
                      )}
                    >
                      <Switch
                        disabled={
                          category_id !== 42 &&
                          category_id !== 43 &&
                          category_id !== 44 &&
                          category_id !== 120
                        }
                        checkedChildren="啟用"
                        unCheckedChildren="停用"
                      />
                    </Form.Item>
                  </div>
                  <div className="flexBox">
                    <Form.Item
                      name="action_type"
                      label="點擊動作"
                      rules={[{ required: true, message: "請選擇點擊動作" }]}
                    >
                      <Radio.Group>
                        <Radio value={0}>不動作</Radio>
                        <Radio value={1}>開啟頁面</Radio>
                        <Radio value={2}>開啟連結</Radio>
                      </Radio.Group>
                    </Form.Item>
                    <Form.Item shouldUpdate noStyle>
                      {() => {
                        if (!this.formRef.current) return <Fragment />;
                        const action_type = this.formRef.current.getFieldValue(
                          "action_type"
                        );
                        if (action_type == 1) {
                          return (
                            <div className="flexBox">
                              <Form.Item
                                {...genFormItemAtrribute("post_id", "頁面編號")}
                              >
                                <InputNumber />
                              </Form.Item>
                              <Form.Item label="編輯頁面">
                                <Button
                                  type="primary"
                                  loading={this.state.isOpeningPost}
                                  onClick={this.openPost}
                                >
                                  開啟頁面編輯器
                                </Button>
                              </Form.Item>
                            </div>
                          );
                        }
                        if (action_type == 2) {
                          return (
                            <Form.Item
                              {...genFormItemAtrribute("link", "開啟連結")}
                              rules={[
                                { type: "url", message: "請填寫正確連結" },
                              ]}
                            >
                              <Input />
                            </Form.Item>
                          );
                        }
                      }}
                    </Form.Item>
                  </div>
                  {[129, 130].includes(category_id) && (
                    <Fragment>
                      <div className="flexBox">
                        <Form.Item
                          name="type"
                          label="消息適用範圍"
                          rules={[
                            { required: true, message: "請選擇消息適用範圍" },
                          ]}
                        >
                          <Radio.Group>
                            <Radio value={0}>全站</Radio>
                            <Radio value={2}>品牌專屬</Radio>
                          </Radio.Group>
                        </Form.Item>
                      </div>
                      <div>
                        <Form.Item shouldUpdate noStyle>
                          {() => {
                            if (!this.formRef.current) return <Fragment />;
                            const type = this.formRef.current.getFieldValue(
                              "type"
                            ); // 2: 品牌
                            if (type === 2) {
                              return (
                                <Form.Item name="brand_ids" label="適用品牌">
                                  <Select
                                    mode="multiple"
                                    showSearch
                                    allowClear
                                    filterOption={(input, option) => {
                                      return option.children
                                        .toUpperCase()
                                        .includes(input.toUpperCase());
                                    }}
                                    dropdownRender={(menu) => (
                                      <div>
                                        {menu}
                                        <Divider style={{ margin: "2px 0" }} />
                                        <div
                                          style={{
                                            padding: "4px 8px 8px 8px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <Checkbox
                                            checked={selectState}
                                            onChange={(e) => {
                                              if (e.target.checked === true) {
                                                this.setState({
                                                  selectState: true,
                                                });
                                                this.formRef.current.setFields([
                                                  {
                                                    name: ["brand_ids"],
                                                    value: brandList.map(
                                                      (brand) => brand.id
                                                    ),
                                                    touched: true,
                                                    validating: false,
                                                    errors: [],
                                                  },
                                                ]);
                                              } else {
                                                this.setState({
                                                  selectState: false,
                                                });
                                                this.formRef.current.setFields([
                                                  {
                                                    name: ["brand_ids"],
                                                    value: [],
                                                    touched: true,
                                                    validating: false,
                                                    errors: [],
                                                  },
                                                ]);
                                              }
                                            }}
                                          >
                                            全選
                                          </Checkbox>
                                        </div>
                                      </div>
                                    )}
                                  >
                                    {brandList.map((brand) => {
                                      return (
                                        <Select.Option
                                          key={brand.id}
                                          value={brand.id}
                                        >
                                          {brand.name}
                                        </Select.Option>
                                      );
                                    })}
                                  </Select>
                                </Form.Item>
                              );
                            }
                          }}
                        </Form.Item>
                      </div>
                    </Fragment>
                  )}
                  <Form.Item
                    {...genFormItemAtrribute("youtube", "Youtube連結")}
                    rules={[{ type: "url", message: "請填寫正確連結" }]}
                    extra={
                      <a
                        href="https://support.google.com/youtube/answer/57741?hl=zh-Hant&co=GENIE.Platform=Desktop"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        複製Youtube連結 <QuestionCircleOutlined />
                      </a>
                    }
                  >
                    <Input
                      disabled={
                        this.getFieldValue("category_id") !== 50 &&
                        category_id !== 122
                      }
                      placeholder="僅供 消息類別: 首頁大版位Banner及活動影片 使用"
                    />
                  </Form.Item>
                  <div className="flexBox">
                    <Form.Item
                      {...genFormItemAtrribute("desc", "消息資訊說明")}
                    >
                      <Input.TextArea defaultValue="內容" rows={3} />
                    </Form.Item>
                  </div>
                  <Divider>消息圖片</Divider>
                  <span>此區塊操作後還需按下上方的「儲存」資料方得保留</span>
                  <div className="flexBox">
                    <Form.Item label="封面" style={{ minHeight: 166 }}>
                      <Form.List name="images">
                        {() => {
                          const url = _.get(
                            this.getFieldValue("images"),
                            "0.url"
                          );
                          return (
                            <Avatar
                              shape="square"
                              size={538}
                              style={{ height: 270, lineHeight: 270 }}
                              icon={<PictureOutlined />}
                              src={url}
                            />
                          );
                        }}
                      </Form.List>
                    </Form.Item>
                  </div>
                  <div className="flexBox">
                    <p>{`封面圖片上傳 ${ImageSize(
                      this.getFieldValue("category_id")
                    )}`}</p>
                  </div>
                  <Form.Item>
                    <div className="flexBox">
                      <Form.Item
                        {...genFormItemAtrribute("images", " ")}
                        valuePropName="fileList"
                        extra="第一張圖片為封面"
                      >
                        <WUpload multiple={true} showUploadList={false}>
                          <Button>
                            <UploadOutlined /> 上傳
                          </Button>
                        </WUpload>
                      </Form.Item>
                    </div>
                    <Form.List name="images">
                      {(fields, { add, remove, move }) => (
                        <div>
                          <Table
                            dataSource={this.getFieldValue("images")}
                            loading={this.state.isLoadingData}
                            pagination={false}
                            rowKey="id"
                            components={{
                              body: {
                                row: DragableBodyRow,
                              },
                            }}
                            onRow={(record, index) => ({
                              index,
                              moveRow: (dragIndex, hoverIndex) =>
                                move(dragIndex, hoverIndex),
                            })}
                            columns={[
                              { dataIndex: "id", title: "#" },
                              {
                                dataIndex: "url",
                                title: "圖片",
                                render: (url, asset) => (
                                  <div
                                    className="tableImg"
                                    style={{ backgroundImage: `url(${url})` }}
                                    alt="avatar"
                                  />
                                ),
                              },
                              {
                                dataIndex: "name",
                                title: "名稱",
                                render: (name, item) =>
                                  this.getFieldValue("images").indexOf(item) ===
                                  0
                                    ? `[封面] ${name}`
                                    : name,
                              },
                              {
                                title: "Action",
                                dataIndex: "id",
                                key: "tools",
                                width: 250,
                                render: (id, record) => (
                                  <List
                                    grid={{ gutter: 4, column: 3 }}
                                    dataSource={[
                                      <DeleteConfirmButton
                                        loading={record.isDeleteData === true}
                                        size="small"
                                        onConfirm={() => {
                                          let images = this.getFieldValue(
                                            "images"
                                          );

                                          remove(images.indexOf(record));
                                        }}
                                      />,
                                      <Button
                                        type="default"
                                        size="small"
                                        icon={<EyeOutlined />}
                                        onClick={() =>
                                          this.setState({
                                            previewImage: { url: record.url },
                                          })
                                        }
                                      >
                                        檢視
                                      </Button>,
                                    ]}
                                    renderItem={(item) => (
                                      <List.Item>{item}</List.Item>
                                    )}
                                  />
                                ),
                              },
                            ]}
                          />
                        </div>
                      )}
                    </Form.List>
                  </Form.Item>
                </React.Fragment>
              )}
            </Form>
          </div>
          <Modal
            visible={this.state.previewImage}
            footer={null}
            onCancel={() => this.setState({ previewImage: null })}
          >
            <img
              alt="Preview"
              style={{ width: "100%" }}
              src={this.state.previewImage && this.state.previewImage.url}
            />
          </Modal>
        </Skeleton>
      </Layout>
    );
  }
}

/* DnD */
let dragingIndex = -1;

class BodyRow extends React.Component {
  render() {
    const {
      isOver,
      connectDragSource,
      connectDropTarget,
      moveRow,
      ...restProps
    } = this.props;
    const style = { ...restProps.style, cursor: "move" };

    let className = restProps.className;
    if (isOver) {
      if (restProps.index > dragingIndex) {
        className += " drop-over-downward";
      }
      if (restProps.index < dragingIndex) {
        className += " drop-over-upward";
      }
    }

    return connectDragSource(
      connectDropTarget(
        <tr {...restProps} className={className} style={style} />
      )
    );
  }
}

const rowSource = {
  beginDrag(props) {
    dragingIndex = props.index;
    return {
      index: props.index,
    };
  },
};

const rowTarget = {
  drop(props, monitor) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Time to actually perform the action
    props.moveRow(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  },
};

const DragableBodyRow = DropTarget("row", rowTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
}))(
  DragSource("row", rowSource, (connect) => ({
    connectDragSource: connect.dragSource(),
  }))(BodyRow)
);

/* DnD */



// WEBPACK FOOTER //
// ./src/views/News/NewsInfo.js